
import { Link } from 'react-router-dom';

export default function FAQCTA() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-12 text-center text-white relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2"></div>
          <div className="relative max-w-2xl mx-auto">
            <i className="ri-compass-3-line text-5xl mb-4 block text-amber-300"></i>
            <h3 className="text-3xl font-bold mb-4">Ready to Make Roseville Home?</h3>
            <p className="text-teal-100 mb-8 text-base leading-relaxed">
              Explore our comprehensive Relocation Guide for step-by-step help with your move, or browse local businesses in our directory.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/relocation"
                className="bg-white text-teal-700 px-8 py-3 rounded-full font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-compass-3-line"></i>
                Relocation Guide
              </Link>
              <Link
                to="/directory"
                className="bg-teal-800 text-white px-8 py-3 rounded-full font-semibold hover:bg-teal-900 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-store-2-line"></i>
                Business Directory
              </Link>
              <Link
                to="/submit-business"
                className="border border-white/30 text-white px-8 py-3 rounded-full font-semibold hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-add-circle-line"></i>
                List Your Business
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
